export const PROFILE_EMPLOYER_COMPANY_BANNER_REMOVE_REQUEST =
  'profile/employer-company-banner-remove-request'
export const PROFILE_EMPLOYER_COMPANY_BANNER_REMOVE_SUCCESS =
  'profile/employer-company-banner-remove-success'
export const PROFILE_EMPLOYER_COMPANY_BANNER_REMOVE_FAILED =
  'profile/employer-company-banner-remove-failed'
